import { FC } from 'react'
import { Typography } from 'antd'
import { TextProps } from 'antd/lib/typography/Text'

export const TextCentered: FC<TextProps> = ({ children, ...props }) => (
  <Typography.Text style={{ textAlign: 'center', display: 'block' }} {...props}>
    {children}
  </Typography.Text>
)
